/* nl-sticky-bar — a fixed bottom bar that appears once the reader has scrolled
   a share of the page.

   Root:   [data-nl-sticky-bar]   data-nl-threshold="0.22" (share of scrollable height, default 0.22)
   Optional: data-nl-threshold-vh="0.9" — trigger after scrolling this many screen heights instead of a
             share of the page. Absent: the share threshold above applies, unchanged.
   Optional: data-nl-threshold-px="700" — trigger after scrolling this many pixels from the top (takes
             priority over -vh and the share). Absent: the rules above apply, unchanged.
   Optional: data-nl-hide-while="<element id>" — the bar stays hidden while that element is on screen
             (TPM build-1: a mobile CTA bar that steps aside over the page's own offer block). Absent:
             no change.
   State:  gets class nl-is-on while the scroll share is above the threshold.
   The section CSS decides whether the bar exists at a given width (e.g. hidden on desktop).
   Lifecycle: re-inits on shopify:section:load, tears down on :unload. */
(function () {
  var instances = {};

  function init(bar) {
    if (!bar || bar.__nlBar) return;
    var threshold = parseFloat(bar.getAttribute('data-nl-threshold'));
    if (isNaN(threshold)) threshold = 0.22;
    var screens = parseFloat(bar.getAttribute('data-nl-threshold-vh'));
    var pixels = parseFloat(bar.getAttribute('data-nl-threshold-px'));
    var section = bar.closest('[id^="shopify-section-"]');
    var hideWhileId = bar.getAttribute('data-nl-hide-while');

    function onScreen() {
      var el = hideWhileId ? document.getElementById(hideWhileId) : null;
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.top < window.innerHeight && r.bottom > 0;
    }

    function shown() {
      if (!isNaN(pixels)) return window.scrollY > pixels;
      if (!isNaN(screens)) return window.scrollY > window.innerHeight * screens;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      return h > 0 && window.scrollY / h > threshold;
    }

    function update() {
      bar.classList.toggle('nl-is-on', shown() && !onScreen());
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    bar.__nlBar = true;
    instances[section ? section.id : 'x'] = function () {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      delete bar.__nlBar;
    };
  }

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-nl-sticky-bar]'), init);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var k = e.target.id || 'x';
    if (instances[k]) { instances[k](); delete instances[k]; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
})();
